import styled from 'styled-components';
import { MdEdit, MdDelete } from 'react-icons/md';

export const Container = styled.div`
  padding: 20px;
`;

export const WrapperTable = styled.div`
  margin-top: 20px;
`;

export const WrapperPopover = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PopoverText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #333;
`;

export const PopoverButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: #122D58;
  color: white;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: #0e2445;
  }
`;

export const EditIcon = styled(MdEdit)`
  font-size: 20px;
  color: #122D58;
  cursor: pointer;
  margin-right: 10px;
  
  &:hover {
    color: #0e2445;
  }
`;

export const DeleteIcon = styled(MdDelete)`
  font-size: 20px;
  color: #f27160;
  cursor: pointer;
  
  &:hover {
    color: #d65a4a;
  }
`;

export const AddButton = styled.div`
  margin-left: 10px;
`;

